import React from "react";
import { Icon } from "../../../../components/Component";
import "./medical-partner-details.css";

const TAB_DEFS = [
  { id: "overview", icon: "info", label: "Overview", needsPrimaryUser: false },
  { id: "teleconsultation", icon: "video", label: "Teleconsultation", needsPrimaryUser: true },
  { id: "clinics", icon: "hospital", label: "Clinics", needsPrimaryUser: true, labelWithCount: true },
  { id: "team", icon: "user", label: "Team", needsPrimaryUser: true },
  { id: "configuration", icon: "grid", label: "Configuration", needsPrimaryUser: true },
  { id: "partnerSettings", icon: "setting", label: "Partner settings", needsPrimaryUser: true },
];

const PRIMARY_USER_TITLE = "Link a primary user account first (Step 1)";

const PartnerDetailTabNav = ({ activeTab, onTabChange, hasPrimaryUser, totalClinics }) => (
  <div className="card-inner border-bottom">
    <ul className="nav nav-tabs nav-tabs-mb-icon mp-detail-tabs">
      {TAB_DEFS.map((tab) => {
        const disabled = tab.needsPrimaryUser && !hasPrimaryUser;
        const label =
          tab.labelWithCount && typeof totalClinics === "number"
            ? `${tab.label} (${totalClinics})`
            : tab.label;
        return (
          <li key={tab.id} className="nav-item">
            <button
              type="button"
              className={`nav-link mp-detail-tab-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => !disabled && onTabChange(tab.id)}
              disabled={disabled}
              title={disabled ? PRIMARY_USER_TITLE : undefined}
            >
              <Icon name={tab.icon} />
              <span>{label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);

export default PartnerDetailTabNav;
